module.exports = __webpack_public_path__ + "img/1000.658ab765.jpg";